module.exports = __webpack_public_path__ + "img/10c282f.jpg";